import { gql } from "@apollo/client";

export const INSERT_PERSON_CONVERSION = gql`
  mutation InsertPersonConversion(
    $person_id: uuid!
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
    $utm_term: String
    $utm_content: String
    $utm_custom: String
    $conversion_type: String!
  ) {
    insert_person_conversion_attribution_one(
      object: {
        person_id: $person_id
        utm_source: $utm_source
        utm_medium: $utm_medium
        utm_campaign: $utm_campaign
        utm_term: $utm_term
        utm_content: $utm_content
        utm_custom: $utm_custom
        conversion_type: $conversion_type
      }
    ) {
      id
      person_id
      utm_source
      utm_medium
      utm_campaign
      utm_term
      utm_content
      utm_custom
      conversion_type
      conversion_datetime
    }
  }
`;
